export default "__VITE_ASSET__BqA9w7d8__"